import React, { useEffect, useState } from 'react';

import ActionButton from '../../elements/ActionButton';
import { ROLE } from '../../helpers/Permissions';
import useNumberParams from '../../hooks/useNumberParams';
import { ROLES } from '../../services/AdminPolicyService';
import axios from '../../services/MyAxios';
import AdminsList from '../admin/AdminsList';
import PermissionsList from '../permissions/PermissionsList';

import RoleDetails from './RoleDetails';

function RoleShow() {
    const { id } = useNumberParams();
    const [role, setRole] = useState({});
    const url = '/crea/api/role/';
    const roleUrl = `/role/${id}`;

    useEffect(() => {
        axios.get(url + id).then((response) => setRole(response.data));
    }, []);

    return (
        <>
            <RoleDetails role={role} />
            <ActionButton url={`${roleUrl}/attach/permission`} title="Attach Permission" roles={[ROLE.SUPER_ADMIN]} />
            <PermissionsList source="role" relatedId={id} showDetach />
            <ActionButton url={`${roleUrl}/attach/admin`} title="Attach Admin" roles={ROLES.MAIN_ADMINS} />
            <AdminsList source="role" relatedId={id} />
        </>
    );
}

export default RoleShow;
